import React, { useEffect, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import EmbedLogoUploader from "components/Reusable/EmbedPageLogoUploader/EmbedLogoUploader.js";
import OrderTrackerScript from "components/Reusable/OrderTrackerScript/OrderTrackerScript.js";
import parse from "html-react-parser";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import useMediaQueries from "hooks/useMediaQueries";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import { useUser } from "contexts/userContext/userContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LogoSide = ({
  diractionPage,
  pageMode,
  closePreviewModeHeader,
  setClosePreviewModeHeader,
  closePreviewDesktop,
  setClosePreviewDesktop,
  titlePage,
  viewType,
  selectedForm,
  logoImage,
  setLogoImage,
  removeImageApi,
  titlePagePlaceHolder,
  changeTextareaTitle,
  textPage,
  brandingColor,
  listIcons,
  newList,
  maxLimitText,
  textPagePlaceHolder,
  descriptionPageRef,
  maxLimitTitle,
  titlePageRef,
  inputImageRef,
  handleNewImage,
  setTextPage,
  showOrderTracker,
  pageLanguage,
  checkOrderStatusText,
  demoPageId,
}) => {
  const { setModal } = useModal();
  const { isSubscribed } = useUser();
  const { newTabletCondition, desktopCondition } = useMediaQueries();
  const { getTextByKey, getDirection } = useContent();
  const [openOrderTracker, setOpenOrderTracker] = useState(false);
  const [trackerCssClass, setTrackerCssClass] = useState(null);
  const [showDescriptionPageLimit, setShowDescriptionPageLimit] =
    useState(false);
  const [showTitlePageLimit, setShowTitlePageLimit] = useState(false);
  let multilineTextarea = null;

  useEffect(() => {
    if (multilineTextarea && pageMode === "edit") {
      multilineTextarea.style.height = "auto";
      multilineTextarea.style.height = multilineTextarea.scrollHeight + "px";
    }

    if (textPagePlaceHolder && multilineTextarea) {
      multilineTextarea.style.height = "auto";
      multilineTextarea.style.height = 120 + "px";
    }
  }, [multilineTextarea, pageMode, textPagePlaceHolder]);

  const changeTextarea = (e) => {
    if (e.length <= maxLimitText) {
      setTextPage(e);
      multilineTextarea.style.height = "auto";
      multilineTextarea.style.height = multilineTextarea.scrollHeight + "px";
    } else {
      const firstLetters = e.substring(0, maxLimitText);
      setTextPage(firstLetters);
      multilineTextarea.style.height = "auto";
      multilineTextarea.style.height = multilineTextarea.scrollHeight + "px";
    }
  };

  useEffect(() => {
    if (openOrderTracker) {
      setTrackerCssClass("bigger");
      setTimeout(() => {
        setTrackerCssClass(null);
      }, 300);
    }
  }, [openOrderTracker]);

  const returnUrlSocial = (item) => {
    switch (item.name.toLowerCase()) {
      case "whatsapp":
        return item.state.startsWith("https")
          ? item.state
          : "https://api.whatsapp.com/send?phone=" + item.state;
      case "email":
        return item.state.includes("mailto:")
          ? item.state
          : "mailto:" + item.state;
      case "phone":
        return item.state.includes("tel:") ? item.state : "tel:" + item.state;
      default:
        return item.state.includes("http") || item.state.includes("https")
          ? item.state
          : "https://" + item.state;
    }
  };
  const firstLetterUpperCase = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const openModalLogoUploader = () => {
    if (isSubscribed()) {
      if (pageMode === "edit") {
        setModal(() => (
          <EmbedLogoUploader
            logoImage={logoImage}
            setLogoImage={setLogoImage}
            removeImageApi={removeImageApi}
          />
        ));
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const handleClickSidePanel = () => {
    if (pageMode === "edit") {
      setClosePreviewModeHeader((prev) => !prev);
    } else {
      if (viewType === "desktop") {
        setClosePreviewDesktop((prev) => !prev);
      } else {
        setClosePreviewModeHeader((prev) => !prev);
      }
    }
  };

  const renderDescriptionPageDemo = () => {
    let descriptionPageDemo = getTextByKey("default-description-embed-page");
    //replace  #business-name# with titlePage
    return descriptionPageDemo.replace("#business-name#", titlePage);
  };

  return (
    <>
      <div
        style={{
          direction:
            demoPageId > 0
              ? getDirection()
              : pageLanguage === "ar" || pageLanguage === "he"
              ? "rtl"
              : "ltr",
        }}
        className={`logo-side ${
          diractionPage === "rtl" ? "right" : "left"
        } ${pageMode} ${
          closePreviewModeHeader ? "logo-side-preivew-close" : ""
        } ${closePreviewDesktop ? "close-preview-desktop" : ""} `}
      >
        {pageMode === "preview" &&
          viewType === "desktop" &&
          !newTabletCondition &&
          selectedForm && (
            <div
              className={`toggle-button ${closePreviewDesktop ? "close" : ""}`}
              onClick={() => setClosePreviewDesktop((prev) => !prev)}
            >
              <Icon
                name={`arrow-${diractionPage === "rtl" ? "right" : "left"}`}
              />
            </div>
          )}
        <div className="logo-top-div">
          {pageMode !== "preview" && !logoImage ? (
            <>
              <div
                className="logo"
                style={{
                  direction:
                    pageLanguage !== "he" && pageLanguage !== "ar"
                      ? "ltr"
                      : "rtl",
                }}
              >
                <div className="add-logo-div">
                  <div
                    className="add-logo add-logo-step1"
                    style={{
                      direction:
                        pageLanguage !== "he" && pageLanguage !== "ar"
                          ? "ltr"
                          : "rtl",
                    }}
                  >
                    <div className="your-logo">
                      <input
                        disabled={pageMode === "first"}
                        accept="image/*"
                        className="input-image-class"
                        name="newImage"
                        type="file"
                        onChange={handleNewImage}
                        ref={inputImageRef}
                      ></input>
                      <span>{getTextByKey("your-logo")}</span>
                      <div className="your-logo-arrow">
                        <Image name="personal/your-logo" alt="" title="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="add-logo-tooltip">
                  <Tooltip
                    id="add-logo-tooltip"
                    tooltipTextKey="add-logo-embed-page-tooltip"
                    end={
                      diractionPage === "rtl"
                        ? false
                        : pageLanguage === "he" || pageLanguage === "ar"
                        ? false
                        : true
                    }
                    start={
                      diractionPage === "ltr"
                        ? false
                        : pageLanguage === "he" || pageLanguage === "ar"
                        ? true
                        : false
                    }
                  >
                    <div className={`tootltip-icon-container`}>
                      <Icon
                        name="question-circle"
                        iconClass="tooltip-question"
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </>
          ) : pageMode !== "preview" && logoImage ? (
            logoImage && (
              <>
                <div
                  className="logo"
                  style={{
                    direction:
                      pageLanguage !== "he" && pageLanguage !== "ar"
                        ? "ltr"
                        : "rtl",
                  }}
                >
                  <div
                    className="logo-edit-preview add-logo-step1"
                    style={{
                      direction:
                        pageLanguage !== "he" && pageLanguage !== "ar"
                          ? "ltr"
                          : "rtl",
                    }}
                  >
                    <Image
                      onClick={() => openModalLogoUploader()}
                      className="image-logo"
                      src={logoImage}
                      alt=""
                      title=""
                    />{" "}
                  </div>
                  <div
                    className="add-logo-tooltip"
                    style={{
                      direction:
                        pageLanguage !== "he" && pageLanguage !== "ar"
                          ? "ltr"
                          : "rtl",
                    }}
                  >
                    <Tooltip
                      id="add-logo-tooltip"
                      tooltipTextKey="add-logo-embed-page-tooltip"
                      end={
                        diractionPage === "rtl"
                          ? false
                          : pageLanguage === "he" || pageLanguage === "ar"
                          ? false
                          : true
                      }
                      start={
                        diractionPage === "ltr"
                          ? false
                          : pageLanguage === "he" || pageLanguage === "ar"
                          ? true
                          : false
                      }
                    >
                      <div className={`tootltip-icon-container`}>
                        <Icon
                          name="question-circle"
                          iconClass="tooltip-question"
                        />
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </>
            )
          ) : (
            <div className="preview-logo">
              {logoImage && <Image src={logoImage} alt="" title="" />}
              {(viewType !== "desktop" || newTabletCondition) &&
                selectedForm && (
                  <div
                    className="panel-button"
                    onClick={() => handleClickSidePanel()}
                  >
                    <Image name="personal/panel-mobile" alt="" title="" />
                  </div>
                )}
            </div>
          )}
        </div>
        <div
          style={{
            direction:
              pageLanguage === "ar" || pageLanguage === "he" ? "rtl" : "ltr",
          }}
          className={`description ${
            closePreviewModeHeader ? "close-preview" : ""
          } `}
        >
          <div className="step-2-embed-page">
            {pageMode !== "preview" ? (
              <div className="title-page-input" ref={titlePageRef}>
                {showTitlePageLimit && (
                  <div className="max-chars">
                    <span className="show-chars" style={{ direction: "ltr" }}>
                      {titlePage.length} / {maxLimitTitle}
                    </span>
                  </div>
                )}
                <input
                  style={{
                    direction: contains_heb(titlePage),
                    textAlign:
                      pageLanguage === "ar" || pageLanguage === "he"
                        ? "right"
                        : "left",
                  }}
                  disabled={pageMode === "first"}
                  onFocus={() => setShowTitlePageLimit(true)}
                  onBlur={() => setShowTitlePageLimit(false)}
                  type="text"
                  className={`titleTextArea ${
                    titlePage.length > 23
                      ? "above23"
                      : titlePage.length > 20
                      ? "above20"
                      : titlePage.length > 18
                      ? "above18"
                      : titlePage.length > 15
                      ? "above15"
                      : titlePage.length > 10
                      ? "above10"
                      : ""
                  } ${titlePagePlaceHolder ? "empty-title" : ""} ${
                    titlePage.length >= 30 ? "max-limit" : ""
                  }`}
                  onChange={(e) => changeTextareaTitle(e.target.value)}
                  value={titlePage}
                  placeholder={
                    titlePagePlaceHolder ? titlePagePlaceHolder : titlePage
                  }
                />
              </div>
            ) : (
              <h1
                style={
                  {
                    // direction: titlePage
                    //   ? contains_heb(titlePage)
                    //   : getDirection(),
                  }
                }
                className={`${
                  titlePage.length > 23
                    ? "above23"
                    : titlePage.length > 20
                    ? "above20"
                    : titlePage.length > 18
                    ? "above18"
                    : titlePage.length > 15
                    ? "above15"
                    : titlePage.length > 10
                    ? "above10"
                    : ""
                }`}
              >
                {titlePage && parse(titlePage)}
              </h1>
            )}
            {pageMode !== "preview" ? (
              <div
                className="description-page-textarea"
                ref={descriptionPageRef}
              >
                <textarea
                  disabled={pageMode === "first"}
                  onFocus={() => setShowDescriptionPageLimit(true)}
                  onBlur={() => setShowDescriptionPageLimit(false)}
                  style={{
                    direction: contains_heb(textPage),
                    textAlign:
                      pageLanguage === "ar" || pageLanguage === "he"
                        ? "right"
                        : "left",
                  }}
                  className={`${textPagePlaceHolder ? "empty-text" : ""} ${
                    textPage.length >= 150 ? "max-limit" : ""
                  }`}
                  ref={(ref) => (multilineTextarea = ref)}
                  //rows={4}
                  onChange={(e) => changeTextarea(e.target.value)}
                  value={textPage}
                  placeholder={
                    textPagePlaceHolder ? textPagePlaceHolder : textPage
                  }
                />
                {showDescriptionPageLimit && (
                  <div className="max-chars">
                    <span className="show-chars" style={{ direction: "ltr" }}>
                      {textPage.length} / {maxLimitText}
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <p
                style={
                  {
                    //direction: textPage ? contains_heb(textPage) : getDirection(),
                  }
                }
              >
                {demoPageId > 0
                  ? renderDescriptionPageDemo()
                  : textPage && parse(textPage)}
              </p>
            )}
          </div>

          {newList && newList.length > 0 && (
            <div className={`social-side ${pageMode}`}>
              <ul
                className={`${
                  newList && newList.length > 9
                    ? "above9"
                    : newList && newList.length > 8
                    ? "above8"
                    : newList && newList.length > 7
                    ? "above7"
                    : newList && newList.length > 6
                    ? "above6"
                    : newList && newList.length < 6
                    ? "less5"
                    : ""
                }`}
              >
                {newList &&
                  newList.map((item, i) => (
                    <li
                      key={i}
                      className={`${
                        newList.length > 9
                          ? "above9"
                          : newList.length > 8
                          ? "above8"
                          : newList.length > 7
                          ? "above7"
                          : newList.length > 6
                          ? "above6"
                          : ""
                      }`}
                    >
                      <Tooltip
                        top
                        //hardPositioned
                        id={`tooltip-${item.name.toLowerCase()}`}
                        tooltipText={firstLetterUpperCase(
                          getTextByKey(
                            item.title.toLowerCase() === "email"
                              ? "signin-email-label"
                              : item.title.toLowerCase(),
                            true
                          )
                        )}
                      >
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={returnUrlSocial(item)}
                          aria-label={item.name}
                        >
                          <FontAwesomeIcon
                            icon={listIcons[item?.name?.toLowerCase()]}
                            style={{ color: brandingColor }}
                          />
                        </a>
                      </Tooltip>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
        {((pageMode === "preview" && viewType === "desktop") ||
          pageMode === "edit") &&
          desktopCondition &&
          showOrderTracker && (
            <div
              style={
                {
                  //direction: titlePage ? contains_heb(titlePage) : getDirection(),
                }
              }
              className={`order-tracker ${
                closePreviewDesktop ? "close-desktop" : ""
              } ${pageMode === "preview" ? "preview-order" : ""}`} //here ${titlePage ? contains_heb(titlePage) : getDirection()}
            >
              <div
                className={`order-tracker-container-embed-page ${
                  openOrderTracker ? "open" : ""
                } ${trackerCssClass}`}
              >
                <div
                  className={`exit-div ${
                    pageLanguage === "ar" || pageLanguage === "he"
                      ? "left"
                      : "right"
                  }`}
                  onClick={() => setOpenOrderTracker(false)}
                >
                  <Icon name="x" />
                </div>
                <OrderTrackerScript
                  isEmbedPage={true}
                  brandingColor={brandingColor}
                  lang={pageLanguage}
                />
              </div>
              <div
                style={
                  {
                    // direction: titlePage
                    //   ? contains_heb(titlePage)
                    //   : diractionPage,
                  }
                }
                className={`order-tracker-text ${
                  openOrderTracker ? "open" : ""
                }`}
                onClick={() =>
                  pageMode !== "first" && setOpenOrderTracker((prev) => !prev)
                }
              >
                <div
                  className="order-tracker-image"
                  style={{ backgroundColor: brandingColor }}
                >
                  <Image name="personal/order-tracker-icon" title="" alt="" />
                </div>
                <span
                  className="text-open-tracker"
                  style={{ color: brandingColor }}
                >
                  {checkOrderStatusText}
                </span>
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default LogoSide;
